import { render, staticRenderFns } from "./DocusignAdditionalDocumentSignTabManagement.vue?vue&type=template&id=6d27a096&"
import script from "./DocusignAdditionalDocumentSignTabManagement.vue?vue&type=script&lang=ts&"
export * from "./DocusignAdditionalDocumentSignTabManagement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports